export const userInfoKey = 'bx-smart-club';
// 默认移动端是 宽度小于750px
export const mobileWidth = 750;